// src/utils/dateUtils.ts
import { MONTHS } from './constants';

export const TODAY = new Date().toISOString().split('T')[0];

export function getToday(): string {
  return new Date().toISOString().split('T')[0];
}

export function addDays(n = 1): string {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().split('T')[0];
}

export function formatDate(s: string | null | undefined): string {
  if (!s) return '';
  const d = new Date(s + 'T00:00:00');
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

export function daysLeft(s: string | null | undefined): number | null {
  if (!s) return null;
  return Math.round(
    (new Date(s + 'T00:00:00').getTime() - new Date(TODAY + 'T00:00:00').getTime()) / 86400000
  );
}

export function isOverdue(s: string | null | undefined): boolean {
  return !!s && s < TODAY;
}

export function isDueToday(s: string | null | undefined): boolean {
  return s === TODAY;
}

export function getDaysInMonth(year: number, month: number): number {
  return new Date(year, month + 1, 0).getDate();
}

export function getFirstDayOfMonth(year: number, month: number): number {
  return new Date(year, month, 1).getDay();
}

export function getLast7Days(): string[] {
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - 6 + i);
    return d.toISOString().split('T')[0];
  });
}

export function getStreak(days: Record<string, string>): number {
  let streak = 0;
  const d = new Date();
  while (true) {
    const ds = d.toISOString().split('T')[0];
    if (days[ds] === 'done') { streak++; d.setDate(d.getDate() - 1); }
    else break;
  }
  return streak;
}

export function formatFullDate(): string {
  return new Date().toLocaleDateString('en-IN', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });
}
